// api
import type {
  EditGatewayDto,
  GatewaysPatchAsyncByidgatewayApiArg,
  ReadGatewayDto,
} from '@/api/generated/recalc/endpoints/v1/gateways';

// shared components
import { EMPTY_ADDRESS_VALUE } from '@/components/ui/form';

// relative
import type { EditGatewayFormValues } from './editGatewayForm.schema';

export function toEditGatewayFormValues(
  gateway: ReadGatewayDto,
): EditGatewayFormValues {
  return {
    name: gateway.Name ?? '',
    description: gateway.Description ?? '',
    address: {
      ...EMPTY_ADDRESS_VALUE,
      latitude: gateway.Latitude ?? null,
      longitude: gateway.Longitude ?? null,
    },
  };
}

export function toPatchGatewayPayload(
  values: EditGatewayFormValues,
  gatewayId: number,
): GatewaysPatchAsyncByidgatewayApiArg {
  const hasCoords =
    values.address.latitude != null && values.address.longitude != null;

  // The generated `EditGatewayDto` types Latitude/Longitude as plain
  // optional numbers, but the PATCH endpoint actually treats an explicit
  // `null` as "clear this field" (matches the legacy gatewayApiSlice.jsx
  // behavior this replaces) - cast once here rather than widening the
  // generated type project-wide.
  const editGatewayDto = {
    Name: values.name.trim(),
    Description: values.description.trim(),
    Latitude: hasCoords ? values.address.latitude : null,
    Longitude: hasCoords ? values.address.longitude : null,
  } as EditGatewayDto;

  return { id: gatewayId, editGatewayDto };
}
